export const createUserFormInformationSlice = (set, get) => ({
  userFormInformation: {},
  updateUserFormInformation: (field, value) => {
    set((state) => ({
      userFormInformation: { ...state.userFormInformation, [field]: value }
    }))
  },
  setUserFormData: (data) => set({ userFormInformation: data }),
  clearUserFormData: () => set({ userFormInformation: {} }),
});
